/** Matches BE copy when collectFreeSticker is blocked for code-gated stickers. */
export function stickerRequiresCollectionCodeMessage(title: string): string {
  const safeTitle = title?.trim() || 'This sticker';
  return `'${safeTitle}' can only be collected with a code.`;
}
